const joinArray = (array, divider = ', ') => {
  if (Array.isArray(array)) {
    return array.join(divider);
  }

  return array || '';
};

export default joinArray;
